import React, { Component } from 'react';
import '../../styles/components/new-drop-down.scss';
import { Loader2 } from 'lucide-react';

class NewDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (this.state.open && this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  toggleDropdown() {
    this.setState((prev) => ({ open: !prev.open }));
  }

  render() {
    const { label, icon: Icon, items, loading } = this.props;

    return (
      <div className="dropdown-wrapper" ref={(node) => (this.wrapperRef = node)}>
        {/* Main Button */}
        <button
          className="btn-new"
          disabled={loading}
          onClick={this.toggleDropdown}
          aria-haspopup="true"
          aria-expanded={this.state.open}
        >
          {loading ? (
            <>
              <Loader2 className="animate-spin" size={18} />
              <span>{label}</span>
            </>
          ) : (
            <>
              {Icon && <Icon size={18} />}
              <span>{label}</span>
            </>
          )}
        </button>

        {/* Dropdown Menu */}
        {this.state.open && (
          <div className="dropdown-menu-custom">
            {items.map((item, i) => (
              <button
                key={i}
                className="dropdown-item-custom"
                onClick={() => {
                  this.setState({ open: false });
                  item.onClick();
                }}
              >
                {item.icon && <item.icon size={16} />}
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default NewDropdown;
